export default (theme) => ({
    marginBottom: theme.spacing(2.7),
    color: theme.palette.error.main,
    fontSize: 10
})
